import apiHeader from '@/helpers/apiHeader';

const modelLogService = {
  listModelLogs(page, params) {
    return apiHeader.get('audits?page=' + page, { params });
  },
  export() {
    return apiHeader.get(`audits/export`, {
      responseType: 'blob', // Pastikan untuk meminta blob
    });
  },
};

export default modelLogService;
